var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-accordion-item",
    {
      staticClass: "accordionForm",
      on: {
        "accordion:open": function ($event) {
          _vm.openedAccordion = true
        },
        "accordion:close": function ($event) {
          _vm.openedAccordion = false
        },
      },
    },
    [
      _c(
        "f7-accordion-toggle",
        { staticClass: "accordionToggle accordionTitleInformation boxRequest" },
        [
          _c(
            "b-row",
            {
              staticClass:
                "documentInformationGrid d-flex justify-content-between align-items-center",
            },
            [
              _c("b-col", { attrs: { cols: "5" } }, [
                _c("div", [
                  _vm.document.Name === "DATA_COMPANY_PRO"
                    ? _c("span", [_vm._v("KBIS")])
                    : _vm.document.Name === "DATA_COMPANY_PART"
                    ? _c("span", [_vm._v("Avis de situation")])
                    : _vm.document.Name === "DATA_RIB"
                    ? _c("span", [_vm._v("RIB")])
                    : _vm.document.Name === "DATA_UBO_PRO"
                    ? _c("span", [_vm._v("Statuts de la société")])
                    : _vm.document.Name === "DATA_WRITER"
                    ? _c("span", [_vm._v("Pièce d'identité")])
                    : _vm.document.Name === "DATA_TAXATION_PRO"
                    ? _c("span", [_vm._v("Bilan")])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("doctypes." + _vm.document.Type + "_general")
                          )
                        ),
                      ]),
                  _vm._v(
                    "\r\n          " +
                      _vm
                        ._s /* $t('suppliers.kyc_form.' + document.Name + '._label') */
                        /*shareholder !== false ?
            $t('doctypes.' + document.Type + '_general') :
            (
              (seller.LegalRepresentativeFirstname !== '' && seller.LegalRepresentativeLastname !== '') ?
              $t('doctypes.' + document.Type, {legalRepresentative : seller.LegalRepresentativeFirstname + ' ' + seller.LegalRepresentativeLastname}) :
              $t('doctypes.' + document.Type + '_legal_representative')
            )*/
                        () +
                      " \r\n\r\n          "
                  ),
                  _vm.document.Status.toString() === "101"
                    ? _c("i", {
                        staticClass: "fa-solid fa-circle-small",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.document.Status.toString() === "102"
                    ? _c("i", {
                        staticClass: "fa-solid fa-circle-small",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.document.Status.toString() === "103"
                    ? _c("i", {
                        staticClass: "fa-solid fa-circle-small",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm.document.Status.toString() === "104"
                    ? _c("i", {
                        staticClass: "fa-solid fa-check",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm.document.Status.toString() === "105"
                    ? _c("i", {
                        staticClass: "fa-solid fa-xmark",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm.document.Status.toString() === "106"
                    ? _c("i", {
                        staticClass: "fa-solid fa-xmark",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm.document.Status.toString() === "15"
                    ? _c("i", {
                        staticClass: "fa-solid fa-xmark",
                        style:
                          "color:" +
                          _vm.getStatusColor(_vm.document.Status.toString()),
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-left",
                  class: _vm.docstatusclass[_vm.document.Status],
                  attrs: { cols: "3" },
                },
                [
                  _c("i", {
                    class: _vm.getStatusIcon(_vm.document.Status.toString()),
                  }),
                  _vm._v(
                    "\r\n        " +
                      _vm._s(
                        _vm.getStatusLabel(
                          _vm.document.Status.toString(),
                          _vm.document.Role
                        )
                      ) +
                      "\r\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "filesRow" }, [
                _vm.fileArray.length !== 0
                  ? _c(
                      "div",
                      _vm._l(_vm.fileArray, function (file) {
                        return _c(
                          "div",
                          { staticClass: "documentInfoFileName" },
                          [
                            _c("div", { staticClass: "w-100 no-gutter" }, [
                              _vm.showValidationButtonsLevel2(
                                _vm.document.Status
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "col-4 px-0" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateDecisionLevel2(
                                                $event,
                                                _vm.document,
                                                "ACCP"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa-solid fa-check",
                                          }),
                                          _vm._v(
                                            "\r\n                  " +
                                              _vm._s(_vm.$t("common.accpt")) +
                                              "\r\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateDecisionLevel2(
                                                $event,
                                                _vm.document,
                                                "RFSL"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa-solid fa-xmark",
                                          }),
                                          _vm._v(
                                            "\r\n                  " +
                                              _vm._s(_vm.$t("common.refus")) +
                                              "\r\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "mr-2 px-0" }, [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadFile(file, $event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(_vm.document.Name) +
                                        "\r\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.editableStatus.includes(
                                "Doc_" + _vm.document.Status
                              )
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFile(file, $event)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass: "fa-light fa-xmark",
                                          staticStyle: {
                                            "margin-right": "-10px",
                                          },
                                        },
                                        [_vm._v("close")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUploadFile(_vm.document)
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn showLargeScreenOnly",
                            class: {
                              uploadedDocumentsList: _vm.fileArray.length !== 0,
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "fileClickButton",
                                on: {
                                  click: function ($event) {
                                    return _vm.openFileSelectionWindow($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.$t("common.add_file")) +
                                    "\r\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn showSmallScreenOnly",
                            class: {
                              uploadedDocumentsList: _vm.fileArray.length !== 0,
                            },
                            staticStyle: { "margin-bottom": "1rem" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "fileClickButton",
                                on: {
                                  click: function ($event) {
                                    return _vm.openFileSelectionWindow($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.$t("common.add_file")) +
                                    "\r\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.institutionalSourceableDocuments.includes(
                  _vm.document.Type
                ) && !_vm.fileArray.length
                  ? _c("div", { staticClass: "btn" }, [
                      _c(
                        "span",
                        {
                          staticClass: "fileClickButton",
                          on: {
                            click: function ($event) {
                              return _vm.callInstitutionalSource($event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\r\n            " +
                              _vm._s(_vm.$t("suppliers.ask_institut")) +
                              "\r\n          "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { ref: "accordionSoftOpener" }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "fileButton",
        staticClass: "item-input hiddenElementAllSize local-file-input",
        attrs: { type: "file" },
        on: { change: _vm.executeOCR },
      }),
      _vm._v(" "),
      _c(
        "f7-accordion-content",
        { staticClass: "background-supplier-document-form" },
        [
          _vm.hasOCRdata &&
          _vm.editableStatus.includes("Doc_" + _vm.document.Status)
            ? _c(
                "div",
                { staticClass: "container-document-form" },
                [
                  _vm.serializeGet.length != 0 && _vm.ocrDone
                    ? _c(
                        "b-row",
                        _vm._l(_vm.serializeGet, function (value) {
                          return _c(
                            "b-col",
                            {
                              key: value.name,
                              staticClass: "form-group",
                              attrs: { sm: "6" },
                            },
                            [
                              _c(
                                "form-write-group-label-input",
                                {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "businessDocuments.serialize" +
                                        _vm.document.Type +
                                        "." +
                                        value.name
                                    ),
                                    inputType:
                                      value.name === "TypeIDCard"
                                        ? "listeSelect"
                                        : "text",
                                    specificErrorIndicator:
                                      _vm.document.Serialize[value.name]
                                        .Valid === "0",
                                    warningIndicator:
                                      _vm.controlsConfig === "1"
                                        ? _vm.showWarningIndicator(
                                            value.name,
                                            _vm.document.Serialize
                                          )
                                        : false,
                                    specificMessage:
                                      _vm.controlsConfig === "1"
                                        ? _vm.getAssociatedMessage(
                                            _vm.document.Serialize[value.name]
                                              .Description
                                          )
                                        : "",
                                  },
                                  model: {
                                    value:
                                      _vm.document.Serialize[value.name].Value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.document.Serialize[value.name],
                                        "Value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "document.Serialize[value.name].Value",
                                  },
                                },
                                [
                                  value.name === "TypeIDCard"
                                    ? _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.document.Serialize[
                                                  value.name
                                                ],
                                              expression:
                                                "document.Serialize[value.name]",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { id: "sel2", readonly: "" },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.document.Serialize,
                                                value.name,
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "businessDocuments.slct_doct_type"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: _vm.$t(
                                                  "ocr.TypeIDCard.National_Identity_Card"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "businessDocuments.idcard_info.National_Identity_Card"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "Passeport" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ocr.TypeIDCard.Passport"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "Titre_sejour" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ocr.TypeIDCard.Titre_sejour"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-start" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4 offset-md-8" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: { click: _vm.uploadDocument },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-plane" }),
                            _vm._v(
                              "\r\n            " +
                                _vm._s(
                                  _vm.shareholder !== false
                                    ? _vm.$t("suppliers.save_info_button")
                                    : _vm.$t(
                                        "businessDocuments.validate_document_button"
                                      )
                                ) +
                                "\r\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm.document.Serialize
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "container-document-form" },
                    _vm._l(_vm.document.Serialize, function (info, index) {
                      return _vm.showWithDependency(
                        info,
                        _vm.document.Serialize
                      ) && info.type !== "file"
                        ? _c(
                            "b-col",
                            {
                              key: index,
                              staticClass: "form-group",
                              attrs: { sm: "6" },
                            },
                            [
                              info.id
                                ? [
                                    info.type === "checkbox"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex flex-row mt-4",
                                          },
                                          [
                                            _c("b-form-checkbox", {
                                              attrs: {
                                                value: "true",
                                                "unchecked-value": "false",
                                              },
                                              model: {
                                                value: info.value,
                                                callback: function ($$v) {
                                                  _vm.$set(info, "value", $$v)
                                                },
                                                expression: "info.value",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              { staticClass: "mb-0" },
                                              [
                                                _vm._v(
                                                  "\r\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "suppliers.kyc_form." +
                                                          _vm.document
                                                            .step_label +
                                                          "." +
                                                          info.label
                                                      )
                                                    ) +
                                                    "\r\n              "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : info.label === "CreationDate" ||
                                        info.label === "DeliveryDate" ||
                                        info.label === "BirthDate"
                                      ? _c("div", [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "suppliers.kyc_form." +
                                                    _vm.document.step_label +
                                                    "." +
                                                    info.label
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: info.value,
                                                expression: "info.value",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm",
                                            attrs: {
                                              disabled: "",
                                              type: "date",
                                            },
                                            domProps: { value: info.value },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  info,
                                                  "value",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "suppliers.kyc_form." +
                                                _vm.document.step_label +
                                                "." +
                                                info.label
                                            ),
                                            inputValue: info.value,
                                          },
                                        }),
                                  ]
                                : [
                                    _vm.document.Type != ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "businessDocuments.serialize." +
                                                _vm.document.Type +
                                                "." +
                                                index
                                            ),
                                            inputValue: info,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "businessDocuments.serialize.BILAN." +
                                                index
                                            ),
                                            inputValue: info,
                                          },
                                        }),
                                  ],
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }